$(document).ready(function () {
	$('.catalog-order--cart [name="p[]"]').change(function () {
		let $container = $(this).closest('.catalog-order--cart');
		let cnt = $container.find('[name="p[]"]:checked').length;
		let $orderConfirm = $('.catalog-order--confirm');

		if (cnt) {
			$orderConfirm.find('.cnt-container').show();
			$orderConfirm.find('.cnt').text(cnt).show();
			$orderConfirm.find('button').text('Подтвердить заказ');
		} else {
			$orderConfirm.find('.cnt-container').hide();
			$orderConfirm.find('button').text('Отказаться от заказа');
		}
	});

	$('.catalog-order--confirm .btn-confirm').click(function () {

	});
});
